module.exports = __webpack_public_path__ + "static/dairy-small-2a9d412a3dae0808ec8c6dc40c509b32.png";